import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconErrorFilledStyle0 = cosmosIconCss;

const CosmosIconErrorFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconErrorFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '71e50013ff29f3e845ea511be92a898b5336aa75', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4bd84f82305e55f020718f63a95522205477b90a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0076c5ce6270ad336198304c1b86d2b1db6077b5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.99 2a9 9 0 1 0 .02 18 9 9 0 0 0-.02-18Zm-.74 4.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-5ZM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconErrorFilledStyle0; }
}, [1, "cosmos-icon-error-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-error-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-error-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconErrorFilled$1);
            }
            break;
    } });
}

const CosmosIconErrorFilled = CosmosIconErrorFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconErrorFilled, defineCustomElement };
